import axios from 'axios';

const baseURL = process.env.REACT_APP_LOCAL_API === 'true' ? 'http://127.0.0.1:5265' : 'https://timetracking-api.ekipman.es';

const api = axios.create({
    baseURL: baseURL,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// TODO: Hacer que si no se tiene token guardado, no cambie el window location a /
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

export default api;